import React, {useMemo} from 'react';
import {Handle, NodeToolbar, Position} from "@xyflow/react";
import {Fab} from "@mui/material";
import {Add as AddIcon,} from "@mui/icons-material";
import {UserAvatar} from "@atttomyx/react-components";
import {ADD_NEW} from "../../constants";
import "./contactNode.css";

const ContactNode = (props) => {
    const {id, data, zIndex, selected} = props;

    const className = useMemo(() => {
        let ret = "contact-node";

        if (selected) {
            ret += " selected";
        }

        return ret;
    }, [selected]);

    const style = useMemo(() => {
        return {
            zIndex: zIndex,
        }
    }, [zIndex]);

    const source = useMemo(() => {
        return data.horizontal ? Position.Right : Position.Bottom;
    }, [data.horizontal]);

    const target = useMemo(() => {
        return data.horizontal ? Position.Left : Position.Top;
    }, [data.horizontal]);

    return (
        <div className={className} style={style}>
            <div className="border"/>
            <UserAvatar
                user={data}
                size="medium"
                // mode="overlay"
                // overlayWidth="96px"
                clickable={false}
            />
            <Handle
                id="source-handle"
                type="source"
                position={source}
                isConnectable={false}
            />
            <Handle
                id="target-handle"
                type="target"
                position={target}
                isConnectable={false}
            />
            <NodeToolbar isVisible={selected} position={source}>
                <Fab
                    size="small"
                    color="primary"
                    title="Add connection"
                    onClick={() => data.setAddConnection({
                        sourceNodeId: id,
                        targetNodeId: ADD_NEW,
                    })}
                >
                    <AddIcon/>
                </Fab>
            </NodeToolbar>
            <NodeToolbar isVisible={selected} position={target}>
                <Fab
                    size="small"
                    color="primary"
                    title="Add connection"
                    onClick={() => data.setAddConnection({
                        sourceNodeId: ADD_NEW,
                        targetNodeId: id,
                    })}
                >
                    <AddIcon/>
                </Fab>
            </NodeToolbar>
        </div>
    )
};

export default ContactNode;
